export default __webpack_public_path__ + "static/media/logo.ceb8c490.svg";